import { Infra3DSDKError } from "./Infra3DSDKError";
export class GraphInfra3DSDKError extends Infra3DSDKError {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, GraphInfra3DSDKError.prototype);
        this.name = "GraphInfra3DSDKError";
    }
}
//# sourceMappingURL=GraphInfra3DSDKError.js.map